export enum buttonSize {
  small = 'sm',
  large = 'lg',
}

export enum buttonColor {
  default = 'default',
  danger = 'danger',
  success = 'success',
  info = 'info',
  primary = 'primary',
  secondary = 'secondary',
}
